/* EditAction.js */

"use strict";
const _ = require("lodash");

class EditAction {
    constructor(logger, gameEditor, activeView, steveIo) {
        this._logger = logger;
        this._activeView = activeView;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this.run = this.run.bind(this);
    }
    run() {
        return Promise.resolve().then(() => {
            let selectedPlanIds = _.get(this._activeView.getSelectedPlanIds(), "selectedRows", []);
            this._activeView.openPlanInstanceEditor(selectedPlanIds);
        });
    }
}
module.exports = EditAction;

EditAction.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.activeView", "$teve.io"];

EditAction.$displayDetails = {
    type: "Action",
    name: "EditAction",
    icon: "osmanager.edit_os_plan",
    shown: true,
    title: "Edit OS Plan",
    order: 3,
};
